import { fromNow } from "../../Helpers/Functions/dateFormat"

export type APIAppAsyncOperationStatus =
    | "SCHEDULED"
    | "IN_PROGRESS"
    | "COMPLETED"
    | "FAILED"

export type APIAppAsyncOperationType =
    | "APP_UPDATED"
    | "CANCEL"
    | "DELETE"
    | "DOWNLOAD"
    | "START"
    | "RELABEL"
    | "POST_PROCESS"

export interface APIAppAsyncOperationModel {
    id: number
    appUuid: string
    created: string
    started: string
    completed: string | null
    status: APIAppAsyncOperationStatus
    type: APIAppAsyncOperationType
    jobUuid?: string
}

export const getAsyncOperationDisplayText = (
    text: string,
    operation: APIAppAsyncOperationModel
) => `${text} (started ${fromNow(operation.created)})`
